import React, { useCallback, useEffect, useState } from 'react';
import moment from 'moment';
import 'moment/locale/pt';
import { useLocation, useNavigate } from 'react-router-dom';

import { AddFilesModal } from '../AddFilesModal';
import { ShowFilesModal } from '../ShowFilesModal';

import ReactLoading from "react-loading";
import { enqueueSnackbar } from 'notistack';
import { GetFetch, PutFetch } from '../../../../services/apiBase';
import FixedContainer from '../../../../components/Container';
import { Box, Button, CircularProgress, Modal, TextField, Typography } from '@mui/material';
import { useAuth } from '../../../../hooks/auth';

const DetalhesTicket = (props) => {
  const { user } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();

  const [ticketId, setTicketId] = useState();
  const [dataId, setDataId] = useState();
  const [ticket, setTicket] = useState(null);
  const [newPost, setNewPost] = useState(false);
  const [closePost, setClosePost] = useState(false);
  const [lastData, setLastData] = useState(null);
  const [files, setFiles] = useState([]);
  const [text, setText] = useState('');

  const [openModalNew, setOpenModalNew] = useState(false);
  const [openShowModal, setOpenShowModal] = useState(false);
  const toggleOpenModalNew = () => setOpenModalNew(!openModalNew);
  const toggleOpenShowModal = () => setOpenShowModal(!openShowModal);
  const [loadingForm, setLoadingForm] = useState(false);

  useEffect(() => {
    if (!location.state) {
      return navigate('/ticket/renovacao/listaTickets')
    } else {
      setTicketId(location.state.ticketId)
    }
  }, [location]);

  const handleOpenData = (dataId) => {
    setDataId(dataId);
    toggleOpenShowModal()
  }

  const handleCloseUpdateForm = () => {
    setClosePost(false)
    setNewPost(false)
  }

  const handleTicketDetails = useCallback(async () => {
    if (ticketId) {
      const response = await GetFetch(`/tickets/${ticketId}`);
      // axios.defaults.headers.authorization = `Bearer ${JWT}`;
      // const response = await axios.get(`http://localhost:4500/tickets/${ticketId}`);
      setTicket(response.data);
    }

  }, [ticketId])

  const handleBackHistory = () => {
    return navigate('/ticket/renovacao/listaTickets')
  };

  const handleUpdate = async (action) => {

    const cleanText = text.trim();
    if (cleanText.length === 0) {
      enqueueSnackbar('O campo de texto é obrigatório para atualizar um ticket.', { variant: 'error' });
      return;
    }
    
    setLoadingForm(true);

    try {

      // GET SIGNED URL
      const contentType = 'multipart/form-data';

      const url = `/tickets/${ticketId}`;

      // const action = 'UPDATE';
      const data = text;
      const username = user.username;

      const fd = new FormData();
      fd.append('action', action);
      fd.append('data', data);
      fd.append('username', username);
      for (let i = 0; i < files.length; i++) {
        fd.append('files', files[i]);
      }

      await PutFetch(
        url, 
        fd,
        {
          headers: {
            'Content-Type': contentType
          }
        }
      )
        
      enqueueSnackbar('Arquivo adicionado com sucesso!', { variant: 'success' });

      // CLEANUP AND CLOSE
      setLoadingForm(false);
      setFiles([]);
      // handleOnCloseModal();
      return navigate('/ticket/renovacao/listaTickets')

    } catch (error) {
      setLoadingForm(false);
      enqueueSnackbar('Erro ao carregar arquivo.', { variant: 'error' });
      return
    }

  }

  useEffect(() => {
    handleTicketDetails()
  }, [ticketId])


  useEffect(() => {
    if (ticket && (ticket.data.length > 0)) {
      setLastData(ticket.data[ticket.data.length -1])
    }
  }, [ticket])

  const statusDict = {
    OPEN: {label: 'Aberto', value: 'OPEN'},
    UPDATE: {label: 'Atualizado', value: 'UPDATE'},
    CLOSE: {label: 'Fechado', value: 'CLOSE'},
    FINISHED: {label: 'Finalizado', value: 'FINISHED'}
  }

  return (
    <FixedContainer>
      <Box sx={{
        width: '100%',
        height: '100%',
        backgroundColor: '#fff',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        boxShadow: 3,
        borderRadius: '10px',
        padding: 2,
      }}>
        {ticket &&
          <>
            <Typography variant='h6' sx={{ fontWeight: 700, fontSize: '18px', paddingBottom: 1 }}>
              Ticket/Detalhes
            </Typography>
            <Box>
              <Box sx={{
                display: 'flex',
                justifyContent: 'flex-end',
                alignItems: 'center'
              }}>
                <Button variant='contained' color="info" onClick={() => handleBackHistory()}>
                  Voltar
                </Button>
              </Box>

              <Typography variant='h4' sx={{ fontSize: '24px', marginX: 1, marginBottom: 2 }}>
                Ticket n° {ticket.id}
              </Typography>
              
              <legend />

              <Box sx={{
                display: 'flex',
                width: '100%',
                flexDirection: 'column',
                marginBottom: '25px',
                gap: 2
              }}>
                <TextField
                  id={`description`}
                  label="Descrição"
                  disabled
                  fullWidth
                  value={ticket.description ? ticket.description : 'Não informado'}
                />

                <Box sx={{
                  display: 'flex',
                  width: '100%',
                  gap: 2
                }}>
                  <TextField
                    id={`status`}
                    label="Status atual"
                    disabled
                    fullWidth
                    value={ticket.current_status ? ticket.current_status : 'Não informado'}
                  />

                  <TextField
                    id={`date`}
                    label="Data da criação"
                    disabled
                    fullWidth
                    value={ticket.created_at ? moment.utc(ticket.created_at).format('DD/MM/YYYY HH:mm') : 'Não informado'}
                  />
                </Box>

                <TextField
                  id={`description`}
                  label="Descrição"
                  disabled
                  fullWidth
                  value={ticket.description ? ticket.created_by : 'Não informado'}
                />
              </Box>

              <Typography variant='h4' sx={{ fontSize: '24px', marginX: 1, marginBottom: 2 }}>
                Histórico
              </Typography>

              {ticket.data.length > 0 ?
                ticket.data.map((item, index) => {
                  // console.log({ item });
                  return (
                    <Box key={index} style={{ margin: '0 0 20px 0' }}>
                      <legend>
                        {
                          item.created_at
                            ? moment.utc(item.created_at)
                              .format('DD/MM/YYYY')
                            : 'Não informado'
                        }
                      </legend>
                      <Box  style={{ padding: '10px', border: '1px solid rgba(0, 0, 0, 0.125)', borderRadius: '0.3rem' }}>
                        
                        <Typography sx={{ padding: '10px', marginBottom: '10px' }}>
                          {item.data ? item.data : 'Não informado'}
                        </Typography>

                        {item.files.length > 0 &&
                          <Box sx={{
                            display: 'flex',
                            flexDirection: 'row',
                            justifyContent: 'flex-end',
                            marginBottom: '10px',
                          }}>
                            <Button
                              key={index}
                              variant='contained'
                              color="success"
                              onClick={() => {
                                handleOpenData(index)
                              }}
                            >
                              Ver anexos
                            </Button>
                          </Box>
                        }
                        <Box sx={{
                          display: 'flex',
                          flexDirection: 'row',
                          justifyContent: 'space-between',
                          borderTop: '1px solid #C1CCD2'
                        }}>
                          <Typography sx={{
                            fontWeight: '700',
                            fontSize: '12px'
                          }}>
                            Usuário: {item.created_by ? item.created_by : 'Não informado'}
                          </Typography>
                          <Typography sx={{
                            fontSize: '12px'
                          }}>
                            {moment.utc(new Date(item.created_at)).format(`DD/MM/YYYY - hh:mm`)}
                          </Typography>
                        </Box>
                      </Box>
                    </Box>

                  )
                })
                :
                <Box sx={{ marginTop: '5px' }}>
                  <Typography>Nenhum dado informado</Typography>
                </Box>
              }

            {(newPost || closePost) && (
              <Box sx={{ marginTop: '50px', marginBottom: '10px' }}>
                <legend>
                  {newPost ? 'Nova postagem' : 'Encerramento de ticket'}
                </legend>

                <TextField
                  id={`text`}
                  label="Texto"
                  fullWidth
                  value={text}
                  onChange={e => { setText(e.target.value) }}
                />
                <Box>
                  {files.map((file, index) => {
                    return (
                      <p key={index}>
                        {file.name}
                      </p>
                    )
                  })}
                </Box>

                <Box sx={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  width: '100%',
                  marginTop: '10px'
                }}>
                  <Button
                    color="primary"
                    variant='contained'
                    onClick={() => { toggleOpenModalNew() }}>
                    Inserir anexo
                  </Button>

                  <Box>
                    <Button
                      sx={{ marginRight: '5px' }}
                      color='error'
                      variant='contained'
                      onClick={() => () => handleCloseUpdateForm()}>
                      Cancelar
                    </Button>

                    {[statusDict.UPDATE.value, statusDict.OPEN.value].includes(ticket.current_status) &&
                      <>
                        <Button
                          style={{ marginRight: '5px' }}
                          color="success"
                          variant='contained'
                          onClick={() => { handleUpdate(newPost ? 'UPDATE' : 'CLOSE') }}>
                          {newPost ? 'Salvar' : 'Confirmar'}
                        </Button>
                      </>
                    }
                  </Box>
                </Box>
              </Box>
            )}

            {!newPost && !closePost && (
                <Box sx={{
                  display: 'flex',
                  width: '100%',
                  justifyContent: 'flex-end',
                  alignItems: 'center',
                }}>
                  {!ticket.is_closed &&
                    <>
                      <Button
                        color="warning"
                        variant='contained'
                        onClick={() => setClosePost(true)}
                        style={{
                          marginRight: '5px'
                        }}
                      >
                        Encerrar
                      </Button>
                      <Button
                        color="success"
                        variant='contained'
                        onClick={() => setNewPost(true)}>
                        Atualizar
                      </Button>
                    </>
                  }
                </Box>
              )}
            </Box>
          </>
        }
        
        <Box sx={{
          display: 'flex',
          width: '100%',
          justifyContent: 'center',
          alignItems: 'center',
        }}>
          {loadingForm && <CircularProgress color='success' />}
        </Box>

        <Modal
          open={openModalNew}
          onClose={toggleOpenModalNew}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <AddFilesModal
            files={files}
            setFiles={setFiles}
            open={openModalNew}
            onClose={() => {
              toggleOpenModalNew();
            }}
          />
        </Modal>

        <Modal
          open={openShowModal}
          onClose={toggleOpenShowModal}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <ShowFilesModal
            selectedIdx={dataId}
            ticket={ticket}
            open={openShowModal}
            onClose={() => {
              toggleOpenShowModal();
            }}
          />
        </Modal>

      </Box>
    </FixedContainer>
  )
}

export default DetalhesTicket;